
import React from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';

interface QRscannerProps {
  onScan: (newText: string) => void;
}

const QRscanner: React.FC<QRscannerProps> = ({ onScan }) => {
  return (
    <Scanner 
      onScan={(result) => {
        if (result && result[0]) {
          onScan(result[0].rawValue);
        }
      }}
    />
  );
};

export default QRscanner;
